type IEvent = 'logout';
type IHandler = (event: IEvent, data: IData) => void;
type IData = object;
type IDisposer = () => void;

export class EventEmitter {
  private subscribers: Record<IEvent, IHandler[]> = {
    logout: [],
  };

  on = (event: IEvent, handler: IHandler): IDisposer => {
    if (!this.subscribers[event].includes(handler)) {
      this.subscribers[event].push(handler);
    }

    return () => this.off(event, handler);
  }

  once = (event: IEvent, handler: IHandler): IDisposer => {
    const wrappedHandler = (event: IEvent, data: IData) => {
      handler(event, data);
      dispose();
    };

    const dispose = () => this.off(event, wrappedHandler);

    this.on(event, wrappedHandler);

    return dispose;
  }

  off = (event: IEvent, handler: IHandler) => {
    this.subscribers[event] = this.subscribers[event].filter(h => h !== handler);
  }

  emit = (event: IEvent, data?: IData) => {
    this.subscribers[event].forEach((handler: IHandler) => {
      handler(event, data);
    });
  }
}

export default new EventEmitter();
